import { Box, useTheme } from '@mui/material'
import { tokens } from '../../theme'
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import Header from '../../components/Header'
import StatBox from '../../components/StatBox'

import React from "react"
import { useState, useEffect } from "react"

import * as Constants from '../../constants'

const Dashboard = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  const [totalDevices, setTotalDevices] = useState('')
  const [totalOnline, setTotalOnline] = useState('')
  const [totalUsers, setTotalUsers] = useState('')
  const [totalNotificationClients, setTotalNotificationClients] = useState('')

  const fetchStats = () => {
    fetch(Constants.HOST + '/stats', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        data = data.data
		  console.log(data)
        setTotalDevices(data.stats.device.toString())
        setTotalOnline(data.stats.online.toString())
        setTotalUsers(data.stats.user.toString())
		setTotalNotificationClients(data.stats.notification_client.toString())
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchStats()
  }, [])

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="Dashboard"
          subtitle="Bem vindo ao painel administrativo"
        />
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        {/* ROW 1 */}
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={totalDevices}
            subtitle="Dispositivos registrados"
            progress="0"
            icon={
              <PointOfSaleIcon
                sx={{ color: colors.greenAccent[600], fontSize: '26px' }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={totalOnline}
            subtitle="Dispositivos online"
            icon={
              <PointOfSaleIcon
                sx={{ color: colors.greenAccent[600], fontSize: '26px' }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={totalUsers}
            subtitle="Usuarios cadastrados"
            progress="0.30"
            increase=""
            icon={
              <PersonAddIcon
                sx={{ color: colors.greenAccent[600], fontSize: '26px' }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={totalNotificationClients}
            subtitle="Clientes de notificações"
            icon={ <NotificationImportantIcon sx={{ color: colors.greenAccent[600], fontSize: '26px' }} /> }
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Dashboard
